import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import employeeReducer from "./employeeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    employees: employeeReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
